module.exports = __webpack_public_path__ + "img/Intro.a7245b3a.png";